<template>
    <div>
        <a-card :title="$t('edit.editActionTitles.speechExplainSets')" :bordered="false">
            <global-single @handleSubmit="saveSpeechExplain" @handleCancel="cancelSpeechExplain">
                <template v-slot:global>
                    <div>
                        <AdsItem
                                :url="form.speech_explain?form.speech_explain:''"
                                frame-type="audio"
                                :title="''"
                                :isEdit="true"
                                :width="'300px'"
                                @updateData="updateSpeechExplain"
                                @deleteData="deleteSpeechExplain"
                        ></AdsItem>
                    </div>
                </template>
                <template v-slot:single>
                    <div class="sence-list">
                        <div class="list-item" v-for="(item,index) in senceList" :key="index">
                            <div class="sence-img">
                                <img :src="item.thumb_path"/>
                            </div>
                            <div class="sence-title">{{item.scene_title}}</div>
                            <div class="sence-bgm">
                                <audio
                                        controls="controls"
                                        alt="example"
                                        :src="item.speech_explain.url?item.speech_explain.url:''"
                                ></audio>
                            </div>
                            <div class="sence-bgm-btn">
                                <material-select :type="2" @selected="updateSingleSpeechExplain">
                                    <template slot="body">
                                        <a-button type="primary" @click="clickSingleSpeechExplain(index)">
                                            {{$t('actionTitles.changeCover')}}
                                        </a-button>
                                    </template>
                                </material-select>
                                <a-button type="danger" v-if="item.speech_explain.url && item.speech_explain.url!=''" style="margin-left: 10px" @click="deleteSingleSpeechExplain(index)">
                                    {{$t('actionTitles.delete')}}
                                </a-button>
                            </div>
                        </div>
                    </div>
                </template>
            </global-single>
        </a-card>
    </div>
</template>

<script>
    import MaterialSelect from "@/components/MaterialSelect";
    import AdsItem from "./AdsItem";
    import {
        mapGetters
    } from "vuex";
    import GlobalSingle from "./GlobalSingle";
    export default {
        name: "SpeechExplainView",
        components:{ GlobalSingle,MaterialSelect,AdsItem },
        data(){
            return{
                form:{},
                senceList:[],
                curSpeechExplainSenceId:''
            }
        },
        computed: {
            ...mapGetters(["vrbase", "userInfo"])
        },
        created() {
            this.senceList = this.$deepClone(this.vrbase.scenes)
            this.form = this.$deepClone(this.vrbase.ads);
        },
        methods:{
            updateSpeechExplain(data){
                this.$set(this.form, "speech_explain", data.url)
            },
            deleteSpeechExplain(){
                this.form.speech_explain = ''
            },
            updateSingleSpeechExplain(data){
                this.$set(this.senceList[this.curSpeechExplainSenceId].speech_explain, "url", data.url)
            },
            clickSingleSpeechExplain(index){
                this.curSpeechExplainSenceId = index
            },
            deleteSingleSpeechExplain(index){
                this.curSpeechExplainSenceId = index
                this.senceList[this.curSpeechExplainSenceId].speech_explain.url = ''
            },
            saveSpeechExplain(){
                const vrbase = {...this.vrbase, ads: this.form,scenes: this.senceList}
                this.$store.dispatch("saveVRBase", {
                    vrbase,
                    showLoading: true,
                }, true);
            },
            cancelSpeechExplain(){
                this.senceList = this.$deepClone(this.vrbase.scenes)
                this.form = this.$deepClone(this.vrbase.ads);
            },
        }
    }
</script>

<style lang="less" scoped>
    .list-item{
        background-color: #2f2f2f;
        border: 1px solid #555;
        padding: 20px;
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        .sence-img{
            width: 70px;
            height: 70px;
            flex-shrink: 0;
            img{
                width: 70px;
                height: 70px;
                object-fit: contain;
            }
        }
        .sence-title{
            flex: 1;
            margin: 0 20px;
            overflow: hidden;
            word-wrap:break-word;
        }
        .sence-bgm{
            flex-shrink: 0;
            margin-right: 20px;
        }
        .sence-bgm-btn{
            width: 140px;
            flex-shrink: 0;
            display: flex;
            .changeCoverBtn {
                background-color: #7101ad;
                border-color: #7101ad;
            }
        }
    }
</style>
